import { render, staticRenderFns } from "./ChatbotThreadShow.vue?vue&type=template&id=650af7e2&"
import script from "./ChatbotThreadShow.vue?vue&type=script&lang=js&"
export * from "./ChatbotThreadShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports